import moment from 'moment';
import { circles } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/circle';

export default {
  getById: (circleId) => AppUsersClient.get(`${resource}/${circleId}`),
  getCirclesCurrentWeek: () => AppUsersClient.get(`${resource}/circlescurrentweek`),
  getCircle: id => AppUsersClient.get(`${resource}/${id}`),
  getForPeriod(startDate, endDate, teamFilter) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getPeriods(startDate, endDate, teamFilter) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getAll(regionFilter) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/getAllSystem/?forRegion=${(regionFilter ? regionFilter : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getCircleForGroup(groupId) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/getCircleForGroup/?forGroup=${(groupId ? groupId : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  create(circle) {
    return AppUsersClient.post(`${resource}`, circle)
  },
  update(circle) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}`, circle)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(circleId, updateTag) {
    return new Promise((resolve, reject) => {
      let index = circles.findIndex(q => q.id === circleId);
      if (index >= 0) {
        circles.splice(index, 1);
      }
      return resolve(circles);
    });
  },
  // delete(projectId, updateTag) {
  //   return new Promise(function(resolve, reject) {
  //     authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.manage']) //projects.manage
  //     .then(accessToken => {
  //       const headers = { 'Authorization': `Bearer ${accessToken}` };
  //       const options = {
  //         headers
  //       };
  //       axios
  //       .delete(`${constants.planningApiBasePath}/projects/${projectId}?updateTag=${updateTag}`, options)
  //         .then(response => {
  //           resolve(response);
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // },
};
